import fetch from '../../../api/fetch';
import { enqueueSnackbar } from '../snackbar';
import { REDUX_ACTIONS } from '../../../shared/config/constants';

export const epicorSyncSignatureHarvest = (params) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_LOADING,
    payload: {
      message: 'Please wait...',
    },
  });

  const body = {
    url: '/sync/harvestsignatures',
    type: 'POST',
    Division: params
  };
  return fetch
    .post('epicorProxy/epicorProxyPost', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then(() => {
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_SUCCESS,
        payload: {
          message: 'Sync completed successfully.',
        },
      });
    })
    .catch(async (error) => {
      dispatch(
        enqueueSnackbar(
          error.message || 'Sync Failed',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_ERROR,
        payload: {
          message: 'Sync Failed',
        },
      });
    });
};
